/* =========================================================
   OPTI + LIFE HOMEPAGE HOTFIX JS
   Adds mobile accordion behavior to Rooted in Truth section.
   ========================================================= */

(function () {
  function initFounderAccordion() {
    document.querySelectorAll('.L7L-founder').forEach(function (section) {
      var content = section.querySelector('.content-col');
      var title = section.querySelector('.title');

      if (!content || !title) return;
      if (content.querySelector('.opti-founder-accordion-toggle')) return;

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'opti-founder-accordion-toggle';
      button.setAttribute('aria-label', 'Open brand story');
      button.setAttribute('aria-expanded', 'false');

      title.insertAdjacentElement('afterend', button);

      button.addEventListener('click', function () {
        var isOpen = section.classList.toggle('is-open');
        button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        button.setAttribute('aria-label', isOpen ? 'Close brand story' : 'Open brand story');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFounderAccordion);
  } else {
    initFounderAccordion();
  }

  document.addEventListener('shopify:section:load', initFounderAccordion);
})();